export default "__VITE_ASSET__2ph9aqVJ__"